import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormlyFieldDictionarySelectComponent } from '@shared/formly/formly-custom-types/dictionary-select.type.component';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { ReactiveFormsModule } from '@angular/forms';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';

const ALL_ID = 'All';

@Component({
  selector: 'formly-field-multi-select',
  template: `
    <input type="text" readonly [id]="elementId" class="wcag-visuallyhidden">
    <ng-select
            wcag-label
            [items]="items"
            [id]="elementId + '_dropdown'"
            [placeholder]="placeholder"
            [inputAttrs]="{'aria-label': label}"
            [formControl]="formControl"
            [multiple]="multiple"
            [closeOnSelect]="false"
            [bindLabel]="props.bindLabel || 'name'"
            [bindValue]="props.bindValue || 'id'"
            [loading]="isLoading"
            [notFoundText]="notFoundText"
            (add)="onAdd($event)">
    </ng-select>
  `,
  imports: [NgSelectModule, ReactiveFormsModule, WCAGLabelDirective],
})
export class FormlyFieldMultiSelectComponent extends FormlyFieldDictionarySelectComponent implements OnInit, OnDestroy {

  multiple = true;

  onAdd(item) {
    if (item.id === ALL_ID) {
      if (this.model[this.field.key as string][0] && this.model[this.field.key as string][0] !== ALL_ID) {
        this.ngSelectComponent.clearModel();
        setTimeout(() => {
          const option = this.ngSelectComponent.itemsList.items.find(opt => opt.value['id'] === item.id);
          this.ngSelectComponent.select(option);
        });
      }
    } else {
      const firstItem = this.model[this.field.key as string][0];
      if (firstItem && firstItem === ALL_ID) {
        this.ngSelectComponent.clearModel();
        setTimeout(() => {
          const option = this.ngSelectComponent.itemsList.items.find(opt => opt.value['id'] === item.id);
          this.ngSelectComponent.select(option);
        });
      }
    }
  }

}
